import React, { useEffect, useState } from "react";
import { Invoices } from "../components/Invoices";
import { fetchInvoice } from "../redux/actions/InvoicesActions";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../components/wrapper-components/CustomPaginationWrapper";
import { Box, Button, Divider, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { InvoiceAddPopUpModal } from "../components/UI/reusable-components/InvoiceComponents/InvoicesAddPopUpModal";
import InvoiceSendAll from "../components/UI/reusable-components/InvoiceComponents/InvoiceSendAll";
import InvoiceSendMarketPlacesAll from "../components/UI/reusable-components/InvoiceComponents/InvoiceSendMarketPlacesAll";

export const InvoicesPage = () => {
  const dispatch = useDispatch();
  const { invoices, totalInvoices } = useSelector((state) => state.invoices);
  const authUserId = useSelector((state) => state?.auth?.user?.id);

  const [pageSize] = useState(10); // Sayfa başına gösterilecek öğe sayısı
  const [currentPage, setCurrentPage] = useState(1); // Mevcut sayfa
  const [openDialog, setOpenDialog] = useState(false);
  const [openSendMarketpleaces, setOpenSendMarketpleaces] = useState(false);
  const [openSendInvoice, setOpenSendInvoice] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const handleAddInvoice = () => {
    setOpenDialog(true);
  };
  const handleSendInvoice = () => {
    setOpenSendInvoice(true);
  };
  const handleSendMarketpleace = () => {
    setOpenSendMarketpleaces(true);
  };
  useEffect(() => {
    if (authUserId) {
      dispatch(fetchInvoice(authUserId, currentPage, pageSize)); // API'den veri çek
    }
  }, [dispatch, authUserId, currentPage, pageSize]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Sayfa değişimini güncelle
  };
  const isDisabled = selectedInvoices.length === 0;
  return (
    invoices && (
      <>
        
        <Box
          sx={{
            padding: { xs: 2, sm: 3 },
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            gap: { xs: 2, sm: 0 },
            mt: { xs: 2, sm: 4 },
            mb: { xs: 2, sm: 3 },
            ml: { xs: 0, sm: 1 },
            backgroundColor: "#F7F9FC",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Title */}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h6"
              sx={{
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                fontWeight: "bold",
                color: "#333",
                fontSize: { xs: "1rem", sm: "1.25rem" },
              }}
            >
              İşlemler
            </Typography>
          </Box>

          {/* Buttons container */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: { xs: 1, sm: 2 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {/* First Button */}
            <Button
              onClick={handleSendInvoice}
              disabled={isDisabled}
              sx={{
                paddingX: { xs: 2, sm: 3 },
                paddingY: { xs: 1, sm: 1.2 },
                backgroundColor: isDisabled ? "#E0E0E0" : "#1F1B45",
                color: isDisabled ? "#A0A0A0" : "white",
                borderRadius: "20px",
                fontWeight: 600,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
                boxShadow: isDisabled
                  ? "none"
                  : "0 4px 8px rgba(31, 27, 69, 0.3)",
                "&:hover": {
                  backgroundColor: isDisabled ? "#E0E0E0" : "#2C285A",
                  boxShadow: isDisabled
                    ? "none"
                    : "0 6px 12px rgba(31, 27, 69, 0.4)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#E0E0E0",
                  color: "#A0A0A0",
                },
              }}
            >
              <AddIcon sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }} />
              Toplu Faturalandır
            </Button>

            {/* Second Button */}
            <Button
              onClick={handleSendMarketpleace}
              disabled={isDisabled}
              sx={{
                paddingX: { xs: 2, sm: 3 },
                paddingY: { xs: 1, sm: 1.2 },
                backgroundColor: isDisabled ? "#E0E0E0" : "#1F1B45",
                color: isDisabled ? "#A0A0A0" : "white",
                borderRadius: "20px",
                fontWeight: 600,
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: { xs: "100%", sm: "auto" },
                boxShadow: isDisabled
                  ? "none"
                  : "0 4px 8px rgba(31, 27, 69, 0.3)",
                "&:hover": {
                  backgroundColor: isDisabled ? "#E0E0E0" : "#2C285A",
                  boxShadow: isDisabled
                    ? "none"
                    : "0 6px 12px rgba(31, 27, 69, 0.4)",
                },
                "&.Mui-disabled": {
                  backgroundColor: "#E0E0E0",
                  color: "#A0A0A0",
                },
              }}
            >
              <AddIcon sx={{ fontSize: { xs: "1rem", sm: "1.2rem" } }} />
              Toplu Pazaryerine Fatura Aktar
            </Button>
          </Box>
        </Box>
        {/* Pagination ve İçerik */}
        {/* <CustomPagination
          data={invoices} // Invoices verisi
          totalItems={totalInvoices} // Toplam fatura sayısı
          pageSize={pageSize}
          onPageChange={handlePageChange}
          propsMapper={(data) => ({ invoices: data })} // Invoices için prop haritası
        > */}
        <Invoices
          invoices={invoices || []}
          totalInvoices={totalInvoices}
          setSelectedInvoices={setSelectedInvoices}
          selectedInvoices={selectedInvoices}
        />
        {/* </CustomPagination> */}

        {/* Modal */}
        <InvoiceAddPopUpModal
          openDialog={openDialog}
          handleCloseDialog={() => setOpenDialog(false)}
        />
        <InvoiceSendAll
          openDialog={openSendInvoice}
          handleCloseDialog={() => setOpenSendInvoice(false)}
          data={selectedInvoices}
        />
        <InvoiceSendMarketPlacesAll
          openDialog={openSendMarketpleaces}
          handleCloseDialog={() => setOpenSendMarketpleaces(false)}
          data={selectedInvoices}
        />
      </>
    )
  );
};
